module.exports = __webpack_public_path__ + "img/collection-memoireRingsBudgetHigh.f7bfa19.jpg";